import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/videos")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="videos"
      label="Vídeos"
      fields={[
        { name: "title", label: "Título", type: "text", required: true },
        { name: "description", label: "Descrição", type: "textarea" },
        {
          name: "video_url",
          label: "Link do Instagram",
          type: "text",
          required: true,
          placeholder: "https://www.instagram.com/reel/XXXXXXXXXXX/",
        },
        {
          name: "platform",
          label: "Plataforma",
          type: "select",
          options: [
            { label: "Instagram", value: "instagram" },
            { label: "YouTube", value: "youtube" },
          ],
        },
        { name: "featured", label: "Destaque", type: "boolean" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Título" },
        { key: "platform", label: "Plataforma" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
